import { RefObject } from 'react';

function useMeasure(which: string, inverted: boolean,
  element: RefObject<HTMLDivElement>) {
  const measureContainer = document.querySelector('#measure');

  function onPointerMove(event: any) {
    if (!element.current || !measureContainer)
      return;

    const rect = element.current.getBoundingClientRect();
    const x = (event.pageX - rect.left) / rect.width * 100;
    let y = (event.pageY - rect.top) / rect.height * 100;
    if (inverted)
      y = 100 - y;

    measureContainer.textContent
      = `${which}: x: ${x.toFixed(1)} y: ${y.toFixed(1)}`;
  }

  function dummy(event: any) {
  }

  return window.location.search.includes('measure') ? onPointerMove : dummy;
}

export default useMeasure;
